import { createStyles } from 'antd-style';

import { FA_SELECTOR } from '../styles/variables';
import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';

export const useTypographyStyles = createStyles(({ token }) => ({
  commonLabelValueLabel: {
    color: ThemeColors.COLOR_GREY_BLUISH2,
    textTransform: 'uppercase',
    lineHeight: 1,
    minHeight: '1em',
    fontSize: token.fontSizeSM,
  },
  commonLabelValueText: {
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    fontWeight: 'bold',
    lineHeight: 1.25,
  },
  typographyLabelCategory: {
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 700,
    color: ThemeColors.COLOR_GREY_BLUISH2,
  },
  disabledBlock: {
    pointerEvents: 'none',
    cursor: 'not-allowed',
  },
  disabledBlock50: {
    opacity: 0.5,
  },
  disabledBlock35: {
    opacity: 0.35,
  },
  labelRow: {
    borderBottom: `1px solid ${ThemeColors.COLOR_GREY8}`,
    padding: `${ThemeSpaces.SPACE_SM}px 0`,
    '&:last-child': {
      borderBottomWidth: 0,
    },
    '&.no-border': {
      borderBottomWidth: 0,
      paddingBottom: ThemeSpaces.SPACE_XS,
    },
    '&.no-border + &': {
      paddingTop: ThemeSpaces.SPACE_XS,
    },
  },
  blockLabelWithValue: {
    '.label': {
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    '.text': {
      flex: 1,
      marginTop: ThemeSpaces.SPACE_XS,
      lineHeight: 1.23,

      '&, & > *': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    '&.size-sm': {
      '.label': { fontSize: ThemeFont.FONT_SIZE_SM_PLUS },
      '.text': { fontSize: ThemeFont.FONT_SIZE_SM_PLUS },
    },
  },
  labelWithValue: {
    '&.nowrap': {
      '.label, .text': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '.text': {
        flex: 1,
      },
      '.text.nl-as-newline': {
        whiteSpace: 'pre-line',
      },
    },
    '&.label-nowrap': {
      '.label': {
        whiteSpace: 'nowrap',
      },
    },
    '&.with-colon': {
      '.label::after': {
        content: "':'",
      },
    },

    '.label': {
      color: ThemeColors.COLOR_GREY_BLUISH2,
      textTransform: 'uppercase',
      lineHeight: 1,
      minHeight: '1em',
      fontSize: token.fontSizeSM,

      '&.size-sm': { width: 70 },
      '&.size-md': { width: 110 },
      '&.size-lg': { width: 140 },
      '&.size-full': {
        width: '100%',

        '& + .text': { width: '100%', flex: 'initial' },
      },
      '&.size-auto': { width: 'auto', marginRight: ThemeSpaces.SPACE_XS },
    },
    '.text': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontWeight: 'bold',
      lineHeight: 1.25,
    },

    '&.size-xs': {
      '.label': { fontSize: ThemeFont.FONT_SIZE_XXS, fontWeight: 500 },
      '.text': { fontSize: ThemeFont.FONT_SIZE_SM_MINUS, fontWeight: 500 },
    },
    '&, &.size-sm': {
      '.label': { fontSize: token.fontSizeSM },
      '.text': { fontSize: ThemeFont.FONT_SIZE_SM_PLUS },
    },
    '&.size-md': {
      '.label': { fontSize: token.fontSizeSM },
      '.text': { fontSize: token.fontSize },
    },
    '&.size-lg': {
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontWeight: 'bold',
      '.label': { fontSize: token.fontSizeSM, lineHeight: 1.5 },
      '.text': { fontSize: token.fontSizeLG },
    },
  },
  inlineLink: {
    alignItems: 'center',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    '.ant-col > &': {
      display: 'flex',
    },
    '&.disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
    '&.loading': {
      cursor: 'not-allowed',
    },
    [`> ${FA_SELECTOR}`]: {
      '&:last-child': {
        marginLeft: token.marginXXS,
      },
      '&:first-child': {
        marginRight: token.marginXXS,
      },
    },
    'li > &': {
      width: '100%',
    },
    '&.size-sm': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
}));
